module.exports = __webpack_public_path__ + "img/UZS.bd3303bb.svg";